import * as React from 'react';
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import UserMenu from "./UserMenu";
import PropTypes from "prop-types";
import {useSelector} from "react-redux";
import {selectRequestState} from "../../store/request/stateSlice";

function Body(props) {


    const state = useSelector(selectRequestState);

    return (
        <Container maxWidth="lg">

            <Box component={props.onSubmit ? 'form' : undefined}
                 onSubmit={props.onSubmit ? e => {
                     e.preventDefault();
                     props.onSubmit();
                 } : undefined}
                 sx={{
                     background  : 'rgba(0,0,0,.5)',
                     padding     : 4,
                     borderRadius: state.step == 1 ? '0 14px 14px 14px' : '14px',
                     position    : 'relative',
                     marginTop   : '120px',
                 }}>

                <Box display="flex" sx={{
                    mb: 3,
                }}>
                    <Box flexGrow={1} py={2}>
                        <Typography variant="h5" color="white" flexGrow={1} fontWeight="bold">
                            {props.title}
                        </Typography>
                    </Box>
                    {state.step != '3_check' && state.step != '3_login' && state.step != '3_register' && (
                        <Box>

                            <UserMenu/>

                        </Box>
                    )}
                </Box>

                {props.children}

            </Box>

        </Container>
    );
}

Body.propTypes = {
    title   : PropTypes.string,
    onSubmit: PropTypes.func,
};

export default Body;